var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallBatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#D4EAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 31V29C26 27.9391 25.5786 26.9217 24.8284 26.1716C24.0783 25.4214 23.0609 25 22 25H16C14.9391 25 13.9217 25.4214 13.1716 26.1716C12.4214 26.9217 12 27.9391 12 29V31",
    stroke: "#0071DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13.1281C26.8578 13.3504 27.6174 13.8513 28.1597 14.5521C28.702 15.2529 28.9962 16.1139 28.9962 17.0001C28.9962 17.8862 28.702 18.7472 28.1597 19.448C27.6174 20.1488 26.8578 20.6497 26 20.8721",
    stroke: "#0071DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31V29C31.9993 28.1137 31.7044 27.2528 31.1614 26.5523C30.6184 25.8519 29.8581 25.3516 29 25.13",
    stroke: "#0071DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21C21.2091 21 23 19.2091 23 17C23 14.7909 21.2091 13 19 13C16.7909 13 15 14.7909 15 17C15 19.2091 16.7909 21 19 21Z",
    stroke: "#0071DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallBatch);
export default __webpack_public_path__ + "static/media/SmallBatch.f1e220f64ca8721cf8924400c36bbc6d.svg";
export { ForwardRef as ReactComponent };